export const OrdersStatuses = {
  WAITING_FOR_APPROVAL: 1,
  ORDER_CONFIRMED: 2,
  BEING_PREPARED: 3,
  WILL_BE_SHIPPED: 4,
  ORDER_SHIPPED: 5,
  ORDER_COMPLETED: 6,
  ORDER_PENDING: 7,
  ORDER_CREATED: 8,
  ORDER_CANCELLED: 0,
  ORDER_REFUND: -1
};

export const OrderStatusColors = {
  "1": "#FFC107",
  "2": "#03A9F4",
  "3": "#795548",
  "4": "#607D8B",
  "5": "#673AB7",
  "6": "#4CAF50",
  "7": "#009688",
  "8": "#01579B",
  "0": "#F44336",
  "-1": "#9d0b01"
};

export const OrderStatusColorsText = {
  "1": "#000",
  "2": "#fff",
  "3": "#fff",
  "4": "#fff",
  "5": "#fff",
  "6": "#fff",
  "7": "#fff",
  "8": "#fff",
  "0": "#fff",
  "-1": "#fff"
};

export const OrderStatusNames = {
  WAITING_FOR_APPROVAL: "Onay Bekliyor",
  ORDER_CONFIRMED: "Onaylandı",
  BEING_PREPARED: "Hazırlanıyor",
  WILL_BE_SHIPPED: "Kargolanacak",
  ORDER_SHIPPED: "Kargoya Verildi",
  ORDER_COMPLETED: "Tamamlandı",
  ORDER_PENDING: "Beklemede",
  ORDER_CREATED: "Sipariş Oluşturuldu",
  ORDER_CANCELLED: "İptal Edildi",
  ORDER_REFUND: "İade Edildi",
};

export const orderStatusesInfo = () => {
  return Object.fromEntries(Object.entries(OrdersStatuses).map(([key, value]) => [value, key]));
};

export const getStatusDetail = (orderStatus) => {
  const statusInfo = orderStatusesInfo();
  const orderStatusAsText = statusInfo[orderStatus];

  return {
    [orderStatusAsText]: orderStatus,
    statusText: OrderStatusNames[orderStatusAsText],
    backgroundColor: OrderStatusColors[orderStatus],
    textColor: OrderStatusColorsText[orderStatus],
    statusNumber: orderStatus,
  };
};

export const RefundCancellationTypes = {
  ORDER_REFUND: OrdersStatuses.ORDER_REFUND,
  ORDER_CANCELLATION: OrdersStatuses.ORDER_CANCELLED,
};

export const CancelRefundStatuses = {
  CANCELLATION_CONFIRMED: 1,
  WAITING_FOR_APPROVAL: 2,
  CANCELLATION_CANCELLED: 3,
};

export const CancelRefundStatusNames = {
  CANCELLATION_CONFIRMED: 'Onaylandı',
  WAITING_FOR_APPROVAL: 'Onay Bekliyor',
  CANCELLATION_CANCELLED: 'Reddedildi',
};

export const cancelRefundStatusesInfo = () => {
  return Object.fromEntries(Object.entries(CancelRefundStatuses).map(([key, value]) => [value, key]));
};

export const cancelRefundStatusDetail = (status) => {
  const statusInfos = cancelRefundStatusesInfo();
  const statusTextAsText = statusInfos[status];

  return {
    [statusTextAsText]: status,
    statusText: CancelRefundStatusNames[statusTextAsText],
    statusNumber: status,
  };
};
